import { render } from "./OilDetail.vue?vue&type=template&id=9113e32e&scoped=true&ts=true"
import script from "./OilDetail.vue?vue&type=script&lang=ts"
export * from "./OilDetail.vue?vue&type=script&lang=ts"

import "./OilDetail.vue?vue&type=style&index=0&id=9113e32e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9113e32e"]])

export default __exports__